import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const permissionsService = {
  get_me_permission: (token, params = {}) => {
    const uri = API_ROUTES.PERMISSIONS.GET_ME_PERMISSION;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
